
jQuery(function ($) {
  // Cache selectors
  var $body = $("body");
  var $hamburger = $(".js-hamburger");
  var $drawer = $(".js-drawer");
  var $header = $(".js-header");
  var $sliderTrack = $(".js-mv-slider-track");
  var $slides = $(".js-mv-slide");
  var $marquee = $(".js-marquee");
  var $inviewItems = $(".js-inview");
  var $contactSelects = $(".contact-form__select");
  var searchParams = new URLSearchParams(window.location.search);
  var isQaMode = searchParams.get("qa") === "1";

  if (isQaMode) {
    $body.addClass("is-qa-mode");
  }

  function closeDrawer() {
    $drawer.removeClass("is-open").attr("aria-hidden", "true");
    $hamburger.attr("aria-expanded", "false").attr("aria-label", "メニューを開く");
    $header.removeClass("is-drawer-open");
    $body.removeClass("is-drawer-open");
  }

  // Drawer menu
  function setupDrawerMenu() {
    $hamburger.on("click", function () {
      var isOpen = $drawer.hasClass("is-open");
      $drawer.toggleClass("is-open", !isOpen).attr("aria-hidden", isOpen ? "true" : "false");
      $hamburger
        .attr("aria-expanded", isOpen ? "false" : "true")
        .attr("aria-label", isOpen ? "メニューを開く" : "メニューを閉じる");
      $header.toggleClass("is-drawer-open", !isOpen);
      $body.toggleClass("is-drawer-open", !isOpen);
    });

    $drawer.find("a").on("click", function () {
      closeDrawer();
    });

    $(document).on("keydown", function (event) {
      if (event.key === "Escape") {
        closeDrawer();
      }
    });
  }

  // MV vertical slider
  function setupMvSlider() {
    var slideIndex = 0;
    var slideCount = $slides.length;
    var transition = $sliderTrack.css("transition");

    if (!($slides.length > 1 && $sliderTrack.length)) {
      return;
    }

    if (isQaMode) {
      $sliderTrack.css("transform", "translateY(0)");
      $slides.removeClass("is-current").eq(0).addClass("is-current");
      return;
    }

    $sliderTrack.append($slides.eq(0).clone().removeClass("is-current").attr("aria-hidden", "true"));

    setInterval(function () {
      $slides.eq(slideIndex % slideCount).removeClass("is-current");
      slideIndex += 1;
      $sliderTrack.css("transform", "translateY(" + slideIndex * -100 + "%)");
      $slides.eq(slideIndex % slideCount).addClass("is-current");
    }, 5000);

    $sliderTrack.on("transitionend", function (event) {
      if (event.originalEvent.propertyName !== "transform" || slideIndex !== slideCount) {
        return;
      }

      slideIndex = 0;
      $sliderTrack.css("transition", "none");
      $sliderTrack.css("transform", "translateY(0)");
      $sliderTrack[0].offsetHeight;
      $sliderTrack.css("transition", transition);
    });
  }

  // MV marquee text
  function setupMarqueeText() {
    var originalText;

    if (!$marquee.length) {
      return;
    }

    originalText = $marquee.text().trim();

    if (isQaMode) {
      $marquee.text(originalText);
      return;
    }

    $marquee.text(originalText + "\u00A0\u00A0" + originalText + "\u00A0\u00A0");
  }

  // Scroll-trigger animation
  function setupInviewAnimation() {
    var observer;

    if (!$inviewItems.length) {
      return;
    }

    if (isQaMode) {
      $inviewItems.addClass("is-inview");
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            $(entry.target).addClass("is-inview");
          }
        });
      },
      { threshold: 0.2 }
    );

    $inviewItems.each(function (_, element) {
      observer.observe(element);
    });
  }

  // Works title underline animation
  function setupWorksTitleLines() {
    var resizeTimer;
    var $titleTexts = $(".works-card__title-text");

    if (!$titleTexts.length) {
      return;
    }

    function splitTitleLines(element) {
      var originalText = element.dataset.originalText || element.textContent;
      var titleElement = element.closest(".works-card__title");
      var titleStyle = titleElement ? window.getComputedStyle(titleElement) : null;
      var lineClamp = titleStyle ? parseInt(titleStyle.webkitLineClamp, 10) : 0;
      var clipsOverflow = titleStyle ? titleStyle.overflow !== "visible" : false;
      var textNode;
      var range;
      var lines = [];
      var currentLine = null;
      var currentTop = null;

      element.dataset.originalText = originalText;
      element.classList.remove("is-line-split");
      element.textContent = originalText;

      if (lineClamp > 0 || clipsOverflow) {
        return;
      }

      textNode = element.firstChild;

      if (!textNode || !originalText.length) {
        return;
      }

      range = document.createRange();

      for (var index = 0; index < originalText.length; index += 1) {
        var rect;
        var rects;

        range.setStart(textNode, index);
        range.setEnd(textNode, index + 1);
        rects = range.getClientRects();
        rect = rects[0];

        if (!rect) {
          if (currentLine) {
            currentLine.text += originalText[index];
          }
          continue;
        }

        if (currentLine === null || Math.abs(rect.top - currentTop) > 2) {
          currentLine = {
            end: index,
            start: index,
            text: "",
          };
          currentTop = rect.top;
          lines.push(currentLine);
        }

        currentLine.end = index + 1;
        currentLine.text = originalText.slice(currentLine.start, currentLine.end);
      }

      range.detach();

      if (!lines.length) {
        return;
      }

      element.textContent = "";
      lines.forEach(function (line, lineIndex) {
        var lineElement = document.createElement("span");

        lineElement.className = "works-card__title-line";
        lineElement.style.setProperty("--works-card-line-index", lineIndex);
        lineElement.textContent = line.text;
        element.appendChild(lineElement);
      });
      element.classList.add("is-line-split");
    }

    function splitAllTitleLines() {
      $titleTexts.each(function (_, element) {
        splitTitleLines(element);
      });
    }

    splitAllTitleLines();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(splitAllTitleLines);
    }

    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(splitAllTitleLines, 150);
    });
  }

  // Contact custom select
  function setupContactCustomSelect() {
    if (!$contactSelects.length) {
      return;
    }

    $contactSelects.each(function (selectIndex, selectElement) {
      var $select = $(selectElement);
      var selectId = $select.attr("id") || "contact-select-" + selectIndex;
      var listId = selectId + "-custom-list";
      var buttonId = selectId + "-custom-button";
      var $label = $('label[for="' + selectId + '"]');
      var labelId = $label.attr("id") || selectId + "-label";
      var isRequired = $select.prop("required");
      var $customSelect = $('<div class="contact-form__custom-select js-contact-custom-select"></div>');
      var $button = $(
        '<button class="contact-form__select-button" type="button" aria-haspopup="listbox" aria-expanded="false"></button>'
      );
      var $buttonText = $('<span class="contact-form__select-button-text"></span>');
      var $list = $('<ul class="contact-form__select-list" role="listbox"></ul>');

      function getSelectableOptions() {
        return $list.find(".contact-form__select-option").not(".is-disabled");
      }

      function setActiveOption($option) {
        $list.find(".contact-form__select-option").removeClass("is-active");

        if ($option && $option.length) {
          $option.addClass("is-active").focus();
        }
      }

      function getSelectedOption() {
        return $list.find('.contact-form__select-option[aria-selected="true"]').not(".is-disabled").first();
      }

      function closeSelect() {
        $customSelect.removeClass("is-open");
        $button.attr("aria-expanded", "false");
      }

      function openSelect() {
        var $selectedOption = getSelectedOption();
        var $firstOption = getSelectableOptions().first();

        $customSelect.addClass("is-open");
        $button.attr("aria-expanded", "true");
        setActiveOption($selectedOption.length ? $selectedOption : $firstOption);
      }

      function updateButton() {
        var selectedText = $select.find("option:selected").text();

        $buttonText.text(selectedText);
        $button.toggleClass("is-placeholder", !$select.val());
        $list.find(".contact-form__select-option").each(function (_, optionElement) {
          var $option = $(optionElement);
          var isSelected = $option.data("value") === $select.val();

          $option.attr("aria-selected", isSelected ? "true" : "false");
          $option.toggleClass("is-selected", isSelected);
        });
      }

      function selectOption($option) {
        if (!$option.length || $option.hasClass("is-disabled")) {
          return;
        }

        $select.val($option.data("value")).trigger("change");
        $customSelect.removeClass("is-invalid");
        $button.attr("aria-invalid", "false");
        updateButton();
        closeSelect();
        $button.focus();
      }

      function moveOption(direction) {
        var $options = getSelectableOptions();
        var $current = $list.find(".contact-form__select-option.is-active").first();
        var currentIndex = $options.index($current);
        var nextIndex = currentIndex + direction;

        if (nextIndex < 0) {
          nextIndex = $options.length - 1;
        }

        if (nextIndex >= $options.length) {
          nextIndex = 0;
        }

        setActiveOption($options.eq(nextIndex));
      }

      $select.attr("id", selectId);
      $label.attr("id", labelId);
      $customSelect.insertBefore($select);
      $customSelect.append($select);

      $button.attr({
        "aria-controls": listId,
        "aria-labelledby": labelId + " " + buttonId,
        id: buttonId,
      });
      $button.append($buttonText);

      $list.attr({
        "aria-labelledby": labelId + " " + buttonId,
        id: listId,
      });

      $select.find("option").each(function (optionIndex, optionElement) {
        var $sourceOption = $(optionElement);
        var $option = $('<li class="contact-form__select-option" role="option" tabindex="-1"></li>');
        var isDisabled = $sourceOption.prop("disabled");

        $option
          .text($sourceOption.text())
          .attr("id", listId + "-option-" + optionIndex)
          .attr("aria-selected", $sourceOption.prop("selected") ? "true" : "false")
          .data("value", $sourceOption.val());

        if (isDisabled) {
          $option.addClass("is-disabled").attr("aria-disabled", "true");
        }

        $list.append($option);
      });

      $customSelect.append($button, $list);
      $select
        .addClass("is-enhanced")
        .attr("tabindex", "-1")
        .attr("aria-hidden", "true")
        .data("is-required", isRequired);

      if (isRequired) {
        $select.removeAttr("required");
        $button.attr("aria-required", "true");
      }

      updateButton();

      $button.on("click", function () {
        if ($customSelect.hasClass("is-open")) {
          closeSelect();
        } else {
          openSelect();
        }
      });

      $button.on("keydown", function (event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openSelect();
        }
      });

      $list.on("click", ".contact-form__select-option", function () {
        selectOption($(this));
      });

      $list.on("keydown", ".contact-form__select-option", function (event) {
        if (event.key === "ArrowDown") {
          event.preventDefault();
          moveOption(1);
        } else if (event.key === "ArrowUp") {
          event.preventDefault();
          moveOption(-1);
        } else if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          selectOption($(this));
        } else if (event.key === "Escape") {
          event.preventDefault();
          closeSelect();
          $button.focus();
        }
      });

      $select.on("change", updateButton);
    });

    $(document).on("click", function (event) {
      if (!$(event.target).closest(".js-contact-custom-select").length) {
        $(".js-contact-custom-select").removeClass("is-open").find(".contact-form__select-button").attr("aria-expanded", "false");
      }
    });

    $(".contact-form").on("submit", function (event) {
      var hasInvalidSelect = false;

      $(this)
        .find(".contact-form__select.is-enhanced")
        .each(function (_, selectElement) {
          var $select = $(selectElement);
          var $customSelect = $select.closest(".js-contact-custom-select");
          var $button = $customSelect.find(".contact-form__select-button");
          var isInvalid = $select.data("is-required") && !$select.val();

          $customSelect.toggleClass("is-invalid", !!isInvalid);
          $button.attr("aria-invalid", isInvalid ? "true" : "false");

          if (isInvalid && !hasInvalidSelect) {
            hasInvalidSelect = true;
            $customSelect.addClass("is-open");
            $button.attr("aria-expanded", "true");
            $button.focus();
          }
        });

      if (hasInvalidSelect) {
        event.preventDefault();
      }
    });
  }

  // Contact privacy checkbox
  function setupContactPrivacyCheckbox() {
    var $privacyInputs = $(".contact-form__privacy-input");

    if (!$privacyInputs.length) {
      return;
    }

    function syncPrivacyState(inputElement) {
      var $input = $(inputElement);
      var $targetLabel = $input.closest(".wpcf7-list-item label");

      if (!$targetLabel.length) {
        $targetLabel = $input.closest(".contact-form__privacy-label");
      }

      $targetLabel.toggleClass("is-checked", $input.prop("checked"));
    }

    $privacyInputs.each(function (_, inputElement) {
      syncPrivacyState(inputElement);
    });

    $(document).on("change", ".contact-form__privacy-input", function () {
      syncPrivacyState(this);
    });
  }

  // Initialize
  setupDrawerMenu();
  setupMvSlider();
  setupMarqueeText();
  setupInviewAnimation();
  setupWorksTitleLines();
  setupContactCustomSelect();
  setupContactPrivacyCheckbox();
});
